// 精准定位
function geolocaltion(resolve) {
    AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
        })

        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete)
        AMap.event.addListener(geolocation, 'error', onError)

        function onComplete(data) {
            // data是具体的定位信息
            // console.log(data);
            resolve(data.addressComponent.province)
            localStorage.setItem('_localCity', data.addressComponent.province)
            localStorage.setItem('_regionCode', data.addressComponent.adcode)
        }

        function onError(data) {
            // 定位出错
            console.log('error', data);
            citySearch(resolve)
        }
    })
}
// IP定位获取当前城市信息
function citySearch(resolve) {
    AMap.plugin('AMap.CitySearch', function () {
        var citySearch = new AMap.CitySearch()
        citySearch.getLocalCity(function (status, result) {
            // console.log(333, status, result);
            if (status === 'complete' && result.info === 'OK') {
                // 查询成功，result即为当前所在城市信息
                resolve(result.province)
                localStorage.setItem('_localCity', result.province)
            } else {
                alert("获取位置信息失败")
                resolve("")
                localStorage.removeItem('_localCity')
            }
        })
    })
}

let getCurrentCityName = function () {
    return new Promise((resolve) => {
        if (localStorage.getItem('_localCity')) {
            resolve(localStorage.getItem("_localCity"))
            return
        }
        geolocaltion(resolve)
    })
}
export default getCurrentCityName